export default __webpack_public_path__ + "static/media/Hair_19_F_C3.e267a8c4.svg";